var map = {
	"./AMX.svg": 8920,
	"./CUP.svg": 4618,
	"./DIN.svg": 5261,
	"./DIS.svg": 5795,
	"./DNK.svg": 7487,
	"./ECA.svg": 6157,
	"./ELO.svg": 4736,
	"./HPC.svg": 9448,
	"./JCB.svg": 795,
	"./MAU.svg": 1354,
	"./UAP.svg": 3888,
	"./VIS.svg": 3850,
	"./VPY.svg": 3960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3407;